import { Link } from 'react-router-dom'
import { Icon } from './Icon'

/** Science experts start all work the same way: by submitting a template, their data and its notes. */
export function ScienceCreateButton() {
  return <Link className="btn science-create-trigger primary" to="/sme/templates/new"><Icon name="plus" />New template</Link>
}
